import axiosInstance from '@/utils/axiosInstance';
const utils = {
 	info() {
		axiosInstance.get('/user/info').then((res) => {
			if (res.data.code === 0) {
				const sync_interval = String(res.data.data.service.sync_interval/60000);
				localStorage.setItem('expire_time_str', res.data.data.expire_time_str);
				localStorage.setItem('service_level', res.data.data.service_level);
				localStorage.setItem('service_name', res.data.data.service.name);
				localStorage.setItem('service_sph_num', res.data.data.service.sph_num);
				localStorage.setItem('service_staff_num', res.data.data.service.staff_num);
				localStorage.setItem('service_lever_rate', res.data.data.service.lever_rate);
				localStorage.setItem('sync_interval', sync_interval);
				localStorage.setItem('sph_num', res.data.data.sph_num);
				localStorage.setItem('staff_num', res.data.data.staff_num);
				localStorage.setItem('user_id', res.data.data.id);
				localStorage.setItem('is_expire', res.data.data.is_expire);
				localStorage.setItem('showUsername', res.data.data.username);
				localStorage.setItem('joint_logo', res.data.data.joint_logo);
				localStorage.setItem('invite_menu_state', res.data.data.invite_menu_state);
				localStorage.setItem('home_banner', res.data.data.home_banner);
				localStorage.setItem('service_shop_num', res.data.data.service.shop_num);
				localStorage.setItem('shop_num', res.data.data.shop_num);
				localStorage.setItem('staff_added_num', res.data.data.service.staff_added_num);
				localStorage.setItem('expire_second', res.data.data.expire_second);
				localStorage.setItem('expire_remind', res.data.data.expire_remind);
				localStorage.setItem('expire_time', res.data.data.expire_time);
			}
		})
  	},
   	config() {
		axiosInstance.get('/user/config').then((res) => {
			if (res.data.code === 0) {
				localStorage.setItem('live_long_material_state', res.data.data.live_long_material_state);
			}
		})
  	}
};

export default utils;